import { useEffect, useState } from 'react';
import { Radio, Heart, MessageSquare, Share2, Eye, Users, TrendingUp } from 'lucide-react';
import { api } from '@/lib/api';
import { formatCurrency, formatNumber } from '@/lib/utils';

export default function MonitorPage() {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 2000);
    return () => clearInterval(id);
  }, []);

  const baseViewers = 8500 + Math.floor(Math.sin(tick / 3) * 1500) + tick * 12;
  const baseGmv = 250000 + tick * 480;
  const interactions = Array.from({ length: 8 }, (_, i) => ({
    user: ['小美', '晴天', '阿龙', '月亮', '糖糖', '小北', '阿楠', '夏目'][i],
    action: ['为主播点赞', '加入粉丝团', '分享了直播间', '下单了一件商品', '留言互动', '关注了主播', '加入了购物车', '发了一条弹幕'][i],
    time: `${Math.floor(Math.random() * 5) + 1} 分钟前`
  }));

  return (
    <div>
      <header className="border-b-2 border-border pb-8 mb-8">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-3 h-3 bg-destructive rounded-full animate-pulse" />
          <div className="text-xs uppercase tracking-widest text-destructive font-space">
            LIVE / {new Date().toLocaleTimeString()}
          </div>
        </div>
        <h1 className="text-[clamp(3rem,12vw,8rem)] font-bold leading-[0.85] tracking-tighter uppercase font-space">
          实时<br />监控<span className="text-primary">.</span>
        </h1>
      </header>

      <section className="grid grid-cols-2 md:grid-cols-4 gap-0 border-2 border-border mb-12">
        {[
          { label: '实时观看', value: formatNumber(baseViewers), icon: Eye, color: 'text-primary' },
          { label: '实时互动', value: formatNumber(baseViewers * 0.15), icon: Heart, color: 'text-destructive' },
          { label: '订单数', value: formatNumber(Math.floor(baseGmv / 250)), icon: Users, color: 'text-info' },
          { label: '实时 GMV', value: formatCurrency(baseGmv), icon: TrendingUp, color: 'text-foreground' }
        ].map((k) => (
          <div key={k.label} className="border-r-2 last:border-r-0 border-border p-6 hover:bg-primary hover:text-black transition-colors duration-200">
            <div className="flex items-center justify-between mb-3">
              <div className="text-xs uppercase tracking-widest text-muted-foreground">{k.label}</div>
              <k.icon className={`w-5 h-5 ${k.color}`} />
            </div>
            <div className="text-3xl md:text-5xl font-bold font-space tracking-tighter tabular-nums">{k.value}</div>
          </div>
        ))}
      </section>

      <section className="grid grid-cols-1 lg:grid-cols-3 gap-0 border-2 border-border">
        <div className="lg:col-span-2 p-6 md:p-8 border-b-2 lg:border-b-0 lg:border-r-2 border-border">
          <div className="flex items-center gap-3 mb-6">
            <Radio className="w-5 h-5 text-destructive animate-pulse" />
            <h2 className="text-2xl font-bold font-space uppercase">直播流预览</h2>
          </div>
          <div className="aspect-video border-2 border-border bg-gradient-to-br from-accent to-background flex items-center justify-center relative overflow-hidden">
            <div className="absolute inset-0 opacity-20" style={{
              backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(218,250,29,0.1) 2px, rgba(218,250,29,0.1) 4px)'
            }} />
            <div className="text-center relative">
              <div className="w-20 h-20 mx-auto border-4 border-primary rounded-full flex items-center justify-center animate-pulse">
                <Radio className="w-10 h-10 text-primary" />
              </div>
              <div className="mt-4 font-space font-bold uppercase tracking-widest">直播中</div>
              <div className="text-xs text-muted-foreground mt-2">{formatNumber(baseViewers)} 人正在观看</div>
            </div>
          </div>
        </div>

        <div className="p-6 md:p-8">
          <h2 className="text-2xl font-bold font-space uppercase mb-6">实时互动</h2>
          <div className="space-y-2">
            {interactions.map((m, i) => (
              <div key={i} className="border-2 border-border p-3 hover:bg-primary hover:text-black transition-colors duration-200">
                <div className="flex items-center justify-between">
                  <span className="font-bold text-sm">{m.user}</span>
                  <span className="text-xs opacity-60 font-space">{m.time}</span>
                </div>
                <div className="text-xs mt-1 opacity-80">{m.action}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
